<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
  import {ContainerMixin} from 'vue-slicksort'
  export default {
    mixins: [ContainerMixin]
  }
</script>



// WEBPACK FOOTER //
// src/components-base/components-custom/drag-sort/fixed-label/fixed-label.vue